import "./geo-ar/field/GeoArFieldLab.css";
import type { FieldRouteContext } from "./geo-ar/field/fieldSessionLogger";
import { SharedArCameraProvider, SharedArCameraSurface } from "./camera/SharedArCamera";
import { GeoArFieldLabPanel } from "./geo-ar/field/GeoArFieldLabPanel";

type TheraARExplorePageProps = {
  onClose?: () => void;
  routeContext?: FieldRouteContext;
};

export function TheraARExplorePage({ onClose, routeContext }: TheraARExplorePageProps) {
  return (
    <SharedArCameraProvider>
      <section className="thera-product-page thera-ar-page thera-ar-camera-first" aria-label="THERA AR Explore">
        <div className="thera-ar-shared-stage">
          <SharedArCameraSurface />
          <GeoArFieldLabPanel onClose={onClose} routeContext={routeContext} />
        </div>
      </section>
    </SharedArCameraProvider>
  );
}
